export enum CityCodeEnum {
    MIAMI = 4544,
    ORLANDO = 3203,
    CANCUN = 1569
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/city-code.enum.ts